import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { LazyLoadingContentDirective } from 'ish-core/directives/lazy-loading-content.directive';
import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { CMSModule } from 'ish-shared/cms/cms.module';
import { ModalDialogLinkComponent } from 'ish-shared/components/common/modal-dialog-link/modal-dialog-link.component';

@Component({
  selector: 'ish-product-shipment',
  templateUrl: './product-shipment.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, AsyncPipe, NgClass, LazyLoadingContentDirective, ModalDialogLinkComponent, CMSModule],
})
export class ProductShipmentComponent implements OnInit {
  private context = inject(ProductContextFacade);

  visible$: Observable<boolean>;
  readyForShipmentMin$: Observable<number>;
  readyForShipmentMax$: Observable<number>;

  ngOnInit() {
    this.visible$ = this.context.select('displayProperties', 'shipment');
    this.readyForShipmentMin$ = this.context.select('product', 'readyForShipmentMin');
    this.readyForShipmentMax$ = this.context.select('product', 'readyForShipmentMax');
  }
}
